import {
  Box,
  Drawer,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import { Dayjs } from "dayjs";
import DatePickerEl from "../../ui/DatePickerEl";
import { shipmentFilter, transportFilter } from "./useOrderFilter";

export const OrderFilter = ({
  open,
  startDate,
  endDate,
  shipment,
  transport,
  handleDateChange,
  handleShipmentChange,
  handleTransportChange,
  onClose,
}: {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  shipment: number;
  transport: number;
  handleDateChange: (time: Dayjs | null, type: string) => void;
  handleShipmentChange: (event: SelectChangeEvent) => void;
  handleTransportChange: (event: SelectChangeEvent) => void;
  onClose: () => void;
  open: boolean;
}) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <Box
        sx={{
          padding: "30px 20px",
          width: "260px",
        }}
      >
        <Stack rowGap={"20px"}>
          <Typography fontSize={"24px"}>Filters</Typography>
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            flexWrap={"wrap"}
            columnGap={"40px"}
            rowGap={"40px"}
          >
            <DatePickerEl
              defaultDate={startDate}
              handleChange={(time) => handleDateChange(time, "start")}
              label="From"
            />
            <DatePickerEl
              defaultDate={endDate}
              handleChange={(time) => handleDateChange(time, "end")}
              label="To"
            />

            <FormControl sx={{ minWidth: 150 }} size="small">
              <InputLabel id="demo-select-small-label">
                Transport company
              </InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={`${transport}`}
                label="Transport company"
                onChange={handleTransportChange}
              >
                {transportFilter.map((el, index) => {
                  return (
                    <MenuItem key={index} value={index}>
                      {el.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 150 }} size="small">
              <InputLabel id="shipment-select-small-label">Shipment</InputLabel>
              <Select
                labelId="shipment-select-small-label"
                id="shipment-select-small"
                value={shipment.toString()}
                label="Shipment"
                onChange={handleShipmentChange}
              >
                {shipmentFilter.map((el, index) => {
                  return (
                    <MenuItem key={index} value={index}>
                      {el.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Stack>
        </Stack>
      </Box>
    </Drawer>
  );
};
